<template>
  <tk-badges
    :items="items"
    :removable="removable"
    :max-width-for-each-badge="300"
    font-weight="bold"
    @remove="removeFilter"
  />
</template>

<script>
import { TkBadges } from '@ota-frontend/ui'
import { SearchCondition } from '@/models'

export default {
  name: 'FilterConditionBadges',

  components: {
    TkBadges,
  },

  model: {
    prop: 'condition',
    event: 'remove',
  },

  props: {
    condition: {
      type: SearchCondition,
      required: true,
    },
    removable: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    params() {
      return SearchCondition.PARAMS
    },
    items() {
      const c = this.condition
      return [
        c.keyword && {
          id: 'keyword',
          name: `キーワード：${c.keyword}`,
        },
        (c.priceFrom || c.priceTo) && {
          id: 'price',
          name: c.priceFrom && c.priceTo
            ? `予算：${c.priceFrom.toLocaleString()}～${c.priceTo.toLocaleString()}円`
            : (
              c.priceFrom
                ? `予算：${c.priceFrom.toLocaleString()}円～`
                : `予算：～${c.priceTo.toLocaleString()}円`
            ),
        },
        ...c.intentions
          .map(group => ({
            id: `intention:${group.codes.join('-')}`,
            name: group.name,
          })),
        ...c.hotels
          .map(h => ({
            id: `hotel:${h.code}`,
            name: `ホテル指定：${h.name}`,
          })),
        c.minHotelRank && {
          id: 'min-hotel-rank',
          name: `ホテルランク：${'★'.repeat(c.minHotelRank)} 以上`,
        },
        c.preferDirectFlight && {
          id: 'direct-flight',
          name: '直行便',
        },
        ...c.trains.map(t => ({
          id: `train:${t.code}`,
          name: t.name,
        })),
        ...c.airlines.map(a => ({
          id: `air:${a.code}`,
          name: a.name,
        })),
        c.seat && {
          id: 'seat-code',
          name: c.seat.name
        },
        c.departurePlaceTime && {
          id: 'departure-place-time-code',
          name: c.isDomestic
            ? `出発：${c.departurePlaceTime.name}`
            : `日本出発：${c.departurePlaceTime.name}`
        },
        c.destinationArrivalTime && {
          id: 'destination-arrival-time',
          name: `現地到着：${c.destinationArrivalTime.name}`
        },
        c.destinationTime && {
          id: 'destination-time-code',
          name: `現地出発：${c.destinationTime.name}`
        },
        c.departurePlaceArrivalTime && {
          id: 'departure-place-arrival-time-code',
          name: `日本到着：${c.departurePlaceArrivalTime.name}`
        },
      ].filter(Boolean)
    },
  },

  methods: {
    // 選択されたバッチに対応した項目をconditionsから削除する
    removeFilter(optionId) {
      const [option, id] = optionId.split(':')
      switch (option) {
        case 'intention':
          this.$emit('remove', this.condition.unselectIntention(id.split('-')))
          break
        case 'hotel':
          this.$emit('remove', this.condition.unselectHotel(id))
          break
        case 'train':
          this.$emit('remove', this.condition.remove(this.params.TRAIN))
          break
        case 'air':
          this.$emit('remove', this.condition.unselectAirline(id))
          break
        case 'keyword':
          this.$emit('remove', this.condition.remove(this.params.KEYWORD))
          break
        case 'price':
          this.$emit('remove', this.condition.removeAll([
            this.params.PRICE_FROM,
            this.params.PRICE_TO,
          ]))
          break
        case 'min-hotel-rank':
          this.$emit('remove', this.condition.remove(this.params.MIN_HOTEL_RANK))
          break
        case 'direct-flight':
          this.$emit('remove', this.condition.remove(this.params.STOPOVER))
          break
        case 'seat-code':
          this.$emit('remove', this.condition.remove(this.params.SEAT_CODE))
          break
        case 'departure-place-time-code':
          this.$emit('remove', this.condition.remove(this.params.DEPARTURE_PLACE_TIME_CODE))
          break
        case 'destination-arrival-time':
          this.$emit('remove', this.condition.remove(this.params.DESTINATION_ARRIVAL_TIME_CODE))
          break
        case 'destination-time-code':
          this.$emit('remove', this.condition.remove(this.params.DESTINATION_TIME_CODE))
          break
        case 'departure-place-arrival-time-code':
          this.$emit('remove', this.condition.remove(this.params.DEPARTURE_PLACE_ARRIVAL_TIME_CODE))
          break
      }
    },
  },
}
</script>
